import { createEventRReducer } from 'react-eventr'
import { combineReducers, Reducer } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { accountReportsReducer } from './account/reports'
import { accountNotificationsReducer } from './account/notifications'
import { profileManagementReducer } from './account/profile-management'
import { accountUserReducer } from './account/user'
import { checkoutReducer } from './checkout'
import { companyDetailReducer } from './companyDetail'
import { reducer as configReducer } from './config'
import { dialogReducer } from './dialog'
import { domainReducer } from './domains'
import { gtmReducer } from './gtm'
import { logReducer } from './logs'
import { orderReducer } from './order'
import { searchReducer } from './search'
import { productsReducer } from './products'
import { reducer as tableReducer } from './table'
import { userReducer } from './user'
import { ordersReducer } from './orders'
import { navMenuReducer } from './navMenu'
import { importValidationReducer } from './import/import-validation'
import { importHistoryReducer } from './account/imports'
import { importSearchReducer } from './import/import-search'
import { importCheckProductsReducer } from './import/import-check-products'
import { invoicesReducer } from './account/invoices/reducer'
import { locationReducer } from './location'

const persistedConfigReducer = persistReducer(
  { key: 'CONFIG_REDUCER', storage: storage, whitelist: ['content'] },
  configReducer
)

const persistedOrderReducer = persistReducer({ key: 'order', storage, whitelist: ['orderId'] }, orderReducer)
const persistedGtmReducer = persistReducer({ key: 'gtm', storage }, gtmReducer)

export const makeRootReducer = (customReducers: Record<string, Reducer>) =>
  combineReducers({
    config: persistedConfigReducer,
    eventr: createEventRReducer(20),
    dialog: dialogReducer,
    table: tableReducer,
    search: searchReducer,
    products: productsReducer,
    logs: logReducer,
    companyDetail: companyDetailReducer,
    domains: domainReducer,
    accountReports: accountReportsReducer,
    accountNotifications: accountNotificationsReducer,
    user: userReducer,
    accountUser: accountUserReducer,
    order: persistedOrderReducer,
    checkout: checkoutReducer,
    gtm: persistedGtmReducer,
    orders: ordersReducer,
    profileManagement: profileManagementReducer,
    navMenu: navMenuReducer,
    importValidation: importValidationReducer,
    importHistory: importHistoryReducer,
    importSearch: importSearchReducer,
    importCheckProducts: importCheckProductsReducer,
    invoices: invoicesReducer,
    location: locationReducer,
    ...customReducers
  })
